import { render, staticRenderFns } from "./LoginButton.vue?vue&type=template&id=64f73460"
import script from "./LoginButton.vue?vue&type=script&lang=ts"
export * from "./LoginButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports